module.exports = __webpack_public_path__ + "img/local_see.ae75314d.svg";